import { Button, Flex, InputError, NumberInputProps } from '@mantine/core'
import React from 'react'
interface ITwoButtonInput extends NumberInputProps {
    label1: string
    label2: string
}
const TwoButtonInput = ({
    label1,
    label2,
    error,
    value,
    onChange = () => {},
}: ITwoButtonInput) => {
    return (
        <Flex direction='column'>
            <Flex gap='xs'>
                <Button
                    className='default-hover-button'
                    bg={value === label1 ? 'fuchasia.4' : 'gray.2'}
                    miw={'130px'}
                    radius='md'
                    onClick={() => onChange!(label1)}
                >
                    {label1}
                </Button>
                <Button
                    className='default-hover-button'
                    miw={'130px'}
                    bg={value === label2 ? 'fuchasia.4' : 'gray.2'}
                    radius='md'
                    onClick={() => onChange!(label2)}
                >
                    {label2}
                </Button>
            </Flex>
            <InputError mt='3px'>{error}</InputError>
        </Flex>
    )
}

export default TwoButtonInput
